export default [
  {
    path: '/polity',
    name: 'Polity',
    component: () => import(/* webpackChunkName: "polity" */ '@/views/Polity/pages/Polity')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import(/* webpackChunkName: "polity" */ '@/views/Polity/pages/Terms')
  },
]
